import { useState, useMemo } from "react";
import { createContext } from "react";

export const JSONataEditorContext = createContext()
export function JSONataContext({ children }) {
    const [value, setValue] = useState("");
    const [output, setOutput] = useState("")
    const [script, setScript] = useState("")
    const [bindings, setBindings] = useState(null)

    const original$ = window.$

    const contextValue = useMemo(
        () => ({
            value, setValue,
            output, setOutput,
            script, setScript,
            bindings, setBindings,
            original$
        }),
        [value, output, script, bindings]
    );

    return (
        <JSONataEditorContext.Provider value={contextValue}>
            {children}
        </JSONataEditorContext.Provider>)
};